import '../charts/pies/pie_chart_view.js.coffee'
Namespace 'Monitoring.Views.SocialContents'

class Monitoring.Views.SocialContents.DashboardView extends Backbone.View
  template: JST["backbone/templates/monitoring/dashboard"]
  className: 'dashboard'
  id: 'monitoring-dashboard'

  events:
    'change .topic-owner' : 'onOwnershipSelectorChange'
    'click #search_social_contents_btn': 'onClickStart'
    'click #edit_topics_done': 'onTopicFilterChange'
    'click .show-charts': 'showCharts'
    'click .show-contents': 'showResults'
    'click .show-domain' : 'showDomain'
    'click .show-assistant': 'showAssistant'
    'click #chart_report': 'onChartReport'
    'click #preview_report': 'onChartReportPreview'
    'click #filters_resize': 'onResizeFilter'

  initialize: (@options = {}) ->
    # TODO: actualmente los tres tipos de dashboards (DashboardQueryView, DashboardReviewView y DashboardAnalysisView) solo diferencian disintas formas de renderear los resultados de las busquedas. Ya que cada vez se empiezan a diferenciar mas tambien en el resto de las cosas del dashboard, estaria bueno llevar la distincion un nivel mas arriba y que las distintas vistas se encarguen tambien del manejo de filtros, charts, acciones y busquedas
    @topics = @options.topics
    @defaultCharts = @options.defaultCharts
    @defaultModeisChart = @options.defaultMode is 'visual'
    @isChartPageActive = @defaultModeisChart
    @availableChannelsByProvider = @options.availableChannelsByProvider
    @firstSearch = false
    @resultsElement = ''
    @scrollPosition = 0
    @filtersRendered = true
    @chartsRendered = true
    @currentUser = Keepcon.currentUser.id
    @accountSettings = Keepcon.currentAccount.monitoringSettings
    @showingFilters = true
    @customerData = {
      settings: Keepcon.applicationSettings.customer,
      enabledForCurrentAccount: Keepcon.currentAccount.customerEnabled,
      users: Keepcon.customerUsers,
      usersGroups: Keepcon.customerUsersGroups
    }
    if @options.session?
      @searchIsPending = true
      @changeSession(@options.session)
      @sessionSharingData = @options.session.shared_session
    else
      @uuid = @options.uuid
      @sessionSharingData = {
        uuid: @uuid
        edit: false
        title: ''
        url: ''
      }
    @sessionList = @options.sessionList || []
    @eventAggregator.bind('searchRealtimeContent', @onSearchRealtimeContent)
    @eventAggregator.bind('showResultsView', @showResults)
    @filterView = destroy: ->
    @chartView = destroy: ->
    @results = destroy: ->
    @domainExplorerView = destroy: ->
    @assistantExplorerView = destroy: ->
    @socialContentsAnalysisView = destroy: ->
    $(window).on('resize', @adjustHeight)
    @listenTo(Backbone, 'copySessionModal:opened', @_hideSessionModal)
    @listenTo(Backbone, 'copySessionModal:closed', @_showSessionModal)

  _showSessionModal: ->
    @$el.find('#new-session .modal').show()

  _hideSessionModal: ->
    @$el.find('#new-session .modal').hide()

  changeSession: (session) =>
    @session = session
    unless @searchQuery
      @searchQuery = new Monitoring.Models.SearchQuery({}, {use_defaults: false, defaultCharts: @defaultCharts})
    if @session # TODO This returns false more often than it should e.g. everytime a campaign session is created. Should @session remain undefined?
      offset = @searchQuery.get('offset')
      number_of_results = @searchQuery.get('number_of_results')
      @searchQuery.set($.parseJSON(@session.query))
      @searchQuery.set('offset', offset)
      @searchQuery.set('number_of_results', number_of_results)
      @uuid = @session.uuid
      @searchQuery.set('uuid', @uuid) # TODO: Remove later: This fixes JSONs created before adding renaming column name to uuid
      @searchQuery.set('lock_version', @session.lock_version)
      @searchQuery.set('name', @session.name or '')
      @searchQuery.set('chart_active', @session.chart_active)
      @isChartPageActive = @session.chart_active

  onTopicFilterChange: =>
    @searchQuery.set('topics', @getSelectedTopics())
    @renameModifiedSession()
    @eventAggregator.trigger('searchQueryChanged', @searchQuery)

  # only rename session if current name was not specified by user
  renameModifiedSession: ->
    return unless @_hasADefaultName()
    firstTopic = @getSelectedTopics()[0]
    sessionName = firstTopic?.name || I18n.t('monitoring.dashboard.all_topics')
    Backbone.trigger('session:tab:rename', @uuid, sessionName)

  _hasADefaultName: ->
    defaultNames = [I18n.t('monitoring.dashboard.all_topics'), (topic.name for topic in @topics)...]
    @searchQuery.get('name') in defaultNames

  onEditTopics: =>
    @$el.find('#edit_topic_body').append(@$el.find('.select-topic'))

    already_selected = @TopicsView.toDescriptionArray()
    _.each @searchQuery.get('topics'), (topic) =>
      @TopicsView.selectByText(topic.name) unless topic.name in already_selected

    @$el.find('#edit_topics_modal').modal()

  selectedTopics: ->
    @$el.find('.select-view .tags .label').length > 0

  getSelectedTopics: ->
    topics = @_getTopicsFromView(@TopicsView)

    if !@TopicOwnership || @TopicOwnership == 'all'
      return [] if topics.length == @topics.length

    if @TopicsView.toArray().indexOf('all-active-topics') != -1
      topics = _.union(topics, @getActiveTopics())
      topics = _.unique(topics, false, (topic) -> topic.id)

    if @TopicsView.toArray().indexOf('all-own-topics') != -1
      topics = _.union(topics, @getOwnTopics())
      topics = _.unique(topics, false, (topic) -> topic.id)

    if @TopicsView.toArray().indexOf('all-own-active-topics') != -1
      topics = _.union(topics, _.intersection(@getActiveTopics(),@getOwnTopics()) )
      topics = _.unique(topics, false, (topic) -> topic.id)

    if @TopicsView.toArray().indexOf('all-listening-topics') != -1
      topics = _.union(topics, @getListeningTopics())
      topics = _.unique(topics, false, (topic) -> topic.id)

    if @TopicsView.toArray().indexOf('all-listening-active-topics') != -1
      topics = _.union(topics, _.intersection(@getActiveTopics(),@getListeningTopics()) )
      topics = _.unique(topics, false, (topic) -> topic.id)

    topics

  _getTopicsFromView: (view) ->
    _.select(@topics, (topic) -> view.toArray().indexOf(topic.id) != -1)

  getSelectedChannels: ->
    @newSessionModalView.getSelectedChannelsWith(@getAvailableChannels())

  onSearchRealtimeContent: (uuid) =>
    if @uuid == uuid
      @results.fetchNewResults()

  restoreResults: ->
    @$el.find('#no_results').before(@resultsElement)

  activate: ->
    if @resultsElement
      @restoreResults()
      @resultsElement = ''
      setTimeout =>
        $(document.body).scrollTop(@scrollPosition)
      , 120
    else if @searchIsPending
      @doNewSearch()
    @eventAggregator.bind('searchQueryChanged', @onSearchQueryChange)
    @eventAggregator.bind('editTopics', @onEditTopics)
    @drawFilterResizeIcon()

  deactivate: ->
    @eventAggregator.unbind('searchQueryChanged', @onSearchQueryChange)
    @eventAggregator.unbind('editTopics', @onEditTopics)
    @scrollPosition = $(document.body).scrollTop()
    @resultsElement = @$el.find('#current_results').detach() if @filtersRendered and @chartsRendered unless @resultsElement

  rename: (name) ->
    @searchQuery.set('name', name)

  onClickStart: (evt) =>
    @newSearch() unless $(evt.currentTarget).hasClass('disabled')

  newSearch: =>
    return @_showMissingTimeoutError() if @_openedReviewModeWithoutTimeout()
    return unless @_canSearch()
    @searchQuery = @createSearchQuery()
    oldName = if @searchQuery then @searchQuery.get('name') else ''
    @searchQuery.set('name', oldName)
    @firstSearch = true
    @doNewSearch()
    @_logNewSessionEvent()

  _logNewSessionEvent: ->
    analyticsEvents.newSession(@_searchMode())

  _openedReviewModeWithoutTimeout: ->
    @selectedTopics() and @inReviewMode() and not Keepcon.currentAccount.dashboardSettings.review_mode_timeout_minutes

  _showMissingTimeoutError: ->
    swal
      title: 'You must set a session timeout in account settings to use Review mode'
      type: 'error'
      showCancelButton: false
      confirmButtonClass: 'btn-danger'
      closeOnConfirm: true

  _canSearch: ->
    @newSessionModalView.canSearch()

  newSearchForMyHistorySession: =>
    @searchQuery = @createSearchQueryForMyHistorySession()
    @searchQuery.set('name', 'My History')
    @firstSearch = true
    @doNewSearch(true)

  isReviewMode: ->
    return false unless @searchQuery
    @searchQuery.get('reviewMode')

  doNewSearch: (forMyHistorySession=false) ->
    @eventAggregator.trigger('newMonitoringSearch', @searchQuery)
    @searchIsPending = false
    @results.destroy()
    @results = @_dashboardResultsView()

    @domainExplorerView = new Monitoring.Views.Dashboards.Modes.DomainExplorerView({ searchQuery: @searchQuery, submodesPermissions: @options.submodesPermissions })
    @$el.find('#domain').append(@domainExplorerView.render().el)
    @domainExplorerView.bind('showTextMode', @showResults)
    @domainExplorerView.bind('showVisualMode', @showCharts)
    @domainExplorerView.bind('showAssistantMode', @showAssistant)
    @domainExplorerView.bind('showFilters', @showFilters)

    @assistantExplorerView = new Monitoring.Views.Dashboards.Modes.AssistantExplorerView({ searchQuery: @searchQuery, submodesPermissions: @options.submodesPermissions })
    @$el.find('#assistant').append(@assistantExplorerView.render().el)
    @assistantExplorerView.bind('showTextMode', @showResults)
    @assistantExplorerView.bind('showVisualMode', @showCharts)
    @assistantExplorerView.bind('showDomainMode', @showDomain)

    @socialContentsAnalysisView = new Monitoring.Views.Dashboards.Modes.Explorer.SocialContentsAnalysisView({ searchQuery: @searchQuery })
    @$el.find('#social-contents-analysis-container').append(@socialContentsAnalysisView.render().el)

    @trigger 'new_search', mode: @_searchMode()
    @_bindResultsEvents(forMyHistorySession)
    @results.render()
    @$el.find('#results').append(@results.el)

  _bindResultsEvents: (forMyHistorySession) ->
    unless forMyHistorySession
      @results.bind('searchStarted', @startSearch)
      @results.bind('searchCompleted', @completeSearch)
      @results.bind('searchCompletedWith', @completeSearchWith)
    @results.bind('restoreFromServer', => @trigger('restoreFromServer', this))
    @results.bind('changeSession', @changeSession)
    @results.bind('onReviewCountUpdated', (total) => @trigger('totalChanges', total))
    @results.bind('totalChanges', (response) => @trigger('totalChanges', response.total))
    @results.bind('showSocialContentsAnalysis', @showSocialContentsAnalysis)
    if not forMyHistorySession
      @results.newSearch()
    else
      @results.newSearch(false, true)
      @eventAggregator.trigger('sessionListChange')
      @eventAggregator.trigger('myHistorySessionCreated', @uuid)

  _dashboardResultsView: ->
    switch @_searchMode()
      when 'review' then new Monitoring.Views.DashboardReviewView(@_dashboardResultsViewOptions())
      when 'analysis' then new Monitoring.Views.Dashboards.Modes.PublicationsView(@_dashboardResultsViewOptions())
      else new Monitoring.Views.DashboardQueryView(@_dashboardResultsViewOptions())

  _dashboardResultsViewOptions: ->
    switch @_searchMode()
      when 'review' then $.extend({},
        @_dashboardResultsViewDefaultOptions(),
        cameFromModerationDashboard: @options.cameFromModerationDashboard
      )
      when 'analysis' then $.extend({},
        @_dashboardResultsViewDefaultOptions(),
        visualization: @options.visualization,
        selectedProvider: @newSessionModalView.selectedProvider
      )
      else @_dashboardResultsViewDefaultOptions()

  _searchMode: ->
    switch
      when @isReviewMode() then 'review'
      when @searchQuery.get('analysisMode') then 'analysis'
      else 'explore'

  _dashboardResultsViewDefaultOptions: ->
    searchQuery: @searchQuery
    currentUser: @currentUser
    accountSettings: @accountSettings
    customerData: @customerData
    submodesPermissions: @options.submodesPermissions

  createSearchQuery: ->
    options = {
      uuid: @uuid,
      topics: [],
      channels: [],
      analysisMode: @inAnalysisMode(),
      reviewMode: @inReviewMode(),
      exploreMode: @inExploreMode(),
      surveyMode: @inSurveyMode(),
      lock_version: @searchQuery.get('lock_version') if @searchQuery
    }
    if @inAnalysisMode()
      options.channels = @getSelectedChannels()
      options.peakpeek_selected_provider = @newSessionModalView.selectedProvider
      options.peakpeek_mode = true
    else
      options.topics = @getSelectedTopics()

    new Monitoring.Models.SearchQuery(options, defaultCharts: @defaultCharts)

  createSearchQueryForMyHistorySession: ->
    new Monitoring.Models.SearchQuery({
      uuid: @uuid
      topics: [] # all topics
      analysisMode: false
      reviewMode: false
      exploreMode: true
      surveyMode: false
      channels: @getSelectedChannels()
      lock_version: @searchQuery.get('lock_version') if @searchQuery
      },
      defaultCharts: @defaultCharts
      moderator: @getModeratorName()
    )

  getModeratorName: ->
    Keepcon.currentUser.email

  onSearchQueryChange: =>
    @results.newSearch(true)

  onChartReport: ->
    charts = @$el.find('#chart-container .item')
    chartReportModal = new Monitoring.Views.ChartExportModal
      searchQuery: @searchQuery
      charts: charts
      dashboard_view: @chartView
      isPreview: false
    chartReportModal.render()
    @$el.find('#chart_export_modal').remove()
    @$el.append(chartReportModal.el)
    @$el.find('#chart_export_modal').modal()

  onChartReportPreview: ->
    charts = @$el.find('#chart-container .item')
    chartReportModal = new Monitoring.Views.ChartExportModal
      searchQuery: @searchQuery
      charts: charts
      dashboard_view: @chartView
      isPreview: true
    chartReportModal.render()
    @$el.find('#chart_export_modal').remove()
    @$el.append(chartReportModal.el)
    @$el.find('#chart_export_modal').modal()

  showResults: =>
    @eventAggregator.trigger('changeStateOnServer', @uuid, 'chart_active', false) if @searchQuery && !@searchQuery.get('analysisMode')
    @searchQuery.changeState('chart_active', false) if @searchQuery
    @hideCharts()
    @hideDomain()
    @hideAssistant()
    @restoreResults() if @resultsElement
    @resultsElement = ''
    @$el.find('#results').removeClass('hidden')
    @hideNotAvailableSubModes()

  showCharts: (pruneResults = true) =>
    @isChartPageActive = true
    @eventAggregator.trigger('changeStateOnServer', @uuid, 'chart_active', true) if @searchQuery && !@searchQuery.get('analysisMode')
    @searchQuery.changeState('chart_active', true) if @searchQuery
    @hideResults()
    @hideDomain()
    @hideAssistant()

    @$el.find('#charts').removeClass('hidden')
    @$el.find('#chart_report').removeClass('hidden')

    @chartView.lazyRender()
    @hideNotAvailableSubModes()
    if @searchQuery.get('show_share_session')
      @searchQuery.changeState('show_share_session', undefined)
      @chartView.onClickShare()

  showDomain: =>
    @hideResults()
    @hideCharts()
    @hideAssistant()
    @$el.find('#domain').removeClass('hidden')
    @domainExplorerView.show()
    @hideFilters()

  showAssistant: =>
    @hideResults()
    @hideCharts()
    @hideDomain()

    @$el.find('#assistant').removeClass('hidden')
    @assistantExplorerView.show()

  showSocialContentsAnalysis: =>
    @socialContentsAnalysisView.show()

  hideResults: =>
    @$el.find('#results').addClass('hidden')

  hideCharts: =>
    @isChartPageActive = false
    @$el.find('#charts').addClass('hidden')
    @$el.find('#results').addClass('hidden')

  hideDomain: =>
    @$el.find('#domain').addClass('hidden')

  hideAssistant: =>
    @$el.find('#assistant').addClass('hidden')

  hideNotAvailableSubModes: =>
    if @options.submodesPermissions
      if !@options.submodesPermissions.domain_explorer
        @$el.find('.show-domain').addClass('hidden')
      if !@options.submodesPermissions.assistant_explorer
        @$el.find('.show-assistant').addClass('hidden')

  showFilters: =>
    if !@showingFilters
      @onResizeFilter()

  hideFilters: =>
    if @showingFilters
      @onResizeFilter()

  startSearch: =>
    @filtersRendered = false
    @chartsRendered = false
    window.scrollTo(0, 0)
    @$el.find('#topic-selector').hide()
    @$el.find('#dashboard-content').removeClass('hide')
    @$el.block()
    @$el.find('#filters').block()
    @$el.find('.top-nav-bar').addClass('disabled') if @searchQuery.get('analysisMode')

  completeSearchWith: (newSearchQuery) =>
    @searchQuery = newSearchQuery
    @completeSearch()

  completeSearch: =>
    if @searchQuery.postSelectionDone()
      @$el.find('.top-nav-bar').removeClass('disabled')
    if !@isChartPageActive
      @loadFilters()
      @$el.unblock()
      @$el.find('.show-charts').hide()
      @showResults()
    else
      @loadFilters(=>
        if @chartView
          @chartView.lazyRender() if @chartView.lazyRender
          @$el.unblock()
          @showCharts(false)
      )
    @_doCompleteSearch()

  _doCompleteSearch: =>
    if @firstSearch
      @firstSearch = false
      @trigger('firstSearch', @_firstSearchName())
    @eventAggregator.trigger('contentReceived', @uuid)
    @eventAggregator.trigger('sessionListChange')
    @domainExplorerView.update(@searchQuery)
    @assistantExplorerView.update(@searchQuery)
    @socialContentsAnalysisView.update(@searchQuery)

  _firstSearchName: ->
    return 'Post analysis' if @searchQuery.get('analysisMode')
    return @getSelectedTopics()[0].name if @getSelectedTopics()[0]
    I18n.t 'monitoring.dashboard.all_topics'

  loadFilters: (callback=->) ->
    onSuccess = (dashboardResults) =>
      if (dashboardResults.error)
        if dashboardResults.exception && dashboardResults.exception.startsWith('date_since is higher than date_until')
          errorMessage = I18n.t('monitoring.dashboard.invalid_query_dates')
        else
          errorMessage = I18n.t('monitoring.dashboard.invalid_query.error')

        window.showError(errorMessage)
        return

      @renderFilters(dashboardResults)
      @renderCharts(dashboardResults)
      @renderExportToWord(dashboardResults)
      if @isChartPageActive
        @showCharts(false)
        @$el.unblock()
      callback()
    $.ajax(
      type: 'POST',
      url: "/monitoring/dashboard/load_filters/",
      data: $.extend({}, @searchQuery.toJSON(), {search_method: @results.defaultSearchMethod}),
      global: false,
      success: onSuccess
      complete: =>
        @$el.find('#filters').unblock()
    )

  renderFilters: (dashboardResults) =>
    @filterView.destroy()
    @filterView = @results.createFilterView(
      @searchQuery,
      dashboardResults,
      @getSelectedTopics(),
      @getSortedAvailableChannelsByProvider()
    )
    if @searchQuery.get('analysisMode')
      @filterView.bind('showPostsSection', @results.showPostsSection)
      @filterView.bind('showContentsSection', @results.showContentsSection)
      @results.bind('disableContentsTab', @filterView.disableContentsTab)
      @results.bind('hideFilters', @hideFilters)
    @$el.find('#filters').append(@filterView.render().el)
    @filtersRendered = true

  renderCharts: (dashboardResults) =>
    @chartView.destroy()
    @chartView = @results.createChartsView(@searchQuery, dashboardResults, @sessionSharingData)
    @$el.find('#charts').append(@chartView.render().el)
    @$el.find('.show-charts').show()
    @chartsRendered = true

  renderExportToWord: (dashboardResults) ->
    clipping = _.find(dashboardResults.facets.type.terms, (type) -> type.term == 'clipping')
    if clipping
      @eventAggregator.trigger('filterApplied', clipping.count)
      @$el.find('.export_to_word_option').css('display', 'block')
    else
      @$el.find('.export_to_word_option').css('display', 'none')

  destroy: ->
    @filterView.destroy()
    @chartView.destroy()
    @deactivate()
    @results.destroy()
    @domainExplorerView.destroy()
    @assistantExplorerView.destroy()
    @socialContentsAnalysisView.destroy()
    $(window).off('resize', @adjustHeight)
    this.remove()
    false

  render: =>
    if @searchQuery?
      selectedTopics = _.map(@searchQuery.get('topics'), (topic) -> parseInt(topic.id))
    else
      selectedTopics = []

    @$el.html @template
    @$el.find('#new-session').html @_newSessionModalView().render().el
#    if @mustCreateMyHistorySession()
#      @createMyHistorySession()
    @updateSessionList(@sessionList)

    $(document).ready () => @_renderSelectViews()
    @adjustHeight()

    list = @$el.find('.dashboard-modes .btn')
    first_button = _.find(list, (e) -> $(e).css('display') != 'none' )
    $(first_button).addClass('active')
    @newSessionModalView.setSelections()
    @

  _newSessionModalView: ->
    @newSessionModalView = new Monitoring.Views.SocialContents.NewSessionModalView
      mustShowAnalysisButton: @mustShowAnalysisButton()
      uuid: @uuid
      sortedAvailableChannelsByProvider: @getSortedAvailableChannelsByProvider()
    @newSessionModalView

  onOwnershipSelectorChange: (value, evt)->
    @TopicOwnership = @$el.find('.topic-owner').val()
    @TopicsView.el.className = "select-view"
    @TopicsView.el.classList.add(@TopicOwnership)

  _renderSelectViews: ->
    topicList = [
      {id:'all-own-topics', name: I18n.t('monitoring.dashboard.topic_modal.all_own'), owned: true, allow_listening: true},
      {id:'all-own-active-topics', name: I18n.t('monitoring.dashboard.topic_modal.all_own_active'), owned: true, allow_listening: true},
      {id:'all-listening-topics', name: I18n.t('monitoring.dashboard.topic_modal.all_listenings'), listening: true},
      {id:'all-listening-active-topics', name: I18n.t('monitoring.dashboard.topic_modal.all_listenings_active'), listening: true},
      {id:'all-active-topics', name: I18n.t('monitoring.dashboard.topic_modal.all_active')},
    ]
    topicList = topicList.concat(@getActiveTopics()).concat(@getInactiveTopics())
    @TopicsView = new App.AllSelectByProviderView(
      multiple: true
      selectedOptions: []
      options: topicList
      valueProperty: 'id'
      descriptionProperty: 'name'
      placeholder: I18n.t('monitoring.dashboard.topic_modal.select')
      width: "97%"
    )
    @TopicsView.el.prepend(@$el.find('.topic-owner')[0])
    @listenTo(@TopicsView, 'change', @updateStartButton)

    @$el.find('#select-topic-' + @uuid).html(@TopicsView.el)
    @$el.find('.chosen-choices .search-field .default').css('width', '175px')

  mustShowAnalysisButton: ->
    !_.isEmpty(@getAvailableChannels())

  getSortedAvailableChannelsByProvider: =>
    ret = {}
    for own provider, channels of @availableChannelsByProvider
      ret[provider] = _.sortBy(channels, (c) -> (c.name || '').toLowerCase())

    allChannels = Object.values(@availableChannelsByProvider).flat()
    ret.all_social_entities = _.sortBy(allChannels, (c) -> (c.name || '').toLowerCase())

    ret

  getAvailableChannels: =>
    _.flatten(channels for own provider, channels of @availableChannelsByProvider)

  mustCreateMyHistorySession: =>
    !window.myHistoryCreated? &&
      !@searchQuery? &&
      @currentUserIsModerator() &&
      @sessionList != [] &&
      !('My History' in _.pluck(@sessionList, 'name'))

  createMyHistorySession: =>
#    @newSearchForMyHistorySession()

  currentUserIsModerator: ->
    return window.isModerator

  updateSessionList: (sessions) =>
    @sessionList = sessions
    @sessionListView = new Monitoring.Views.SocialContents.SessionListView
      sessions: @sessionList
    @sessionListView.bind('destroyFromRestore', => @trigger('destroyFromRestore'))
    @$el.find('#session_list').html @sessionListView.render().el

  getActiveTopics: ->
    _.select(@topics, (topic) -> topic.started)

  getOwnTopics: ->
    _.select(@topics, (topic) -> !!topic.owned)

  getListeningTopics: ->
    _.select(@topics, (topic) -> !!topic.listening)

  getInactiveTopics: ->
    _.select(@topics, (topic) -> not topic.started)

  inReviewMode: ->
    @newSessionModalView.inReviewMode()

  inExploreMode: ->
    @newSessionModalView.inExploreMode()

  inAnalysisMode: ->
    @newSessionModalView.inAnalysisMode()

  inSurveyMode: ->
    @newSessionModalView.inSurveyMode()

  updateStartButton: =>
    @newSessionModalView.updateStartButton()

  adjustHeight: =>
    headerHeight = $('#main-header').outerHeight(true)
    tabsHeight = $('#tabs-wrapper').outerHeight(true)
    @$el.find('.mini-scrollbar').css(
      'height',
      "calc(100vh - #{headerHeight + tabsHeight}px)"
    )

  cleanTopicName: (topicName)=>
    topicName.replace /"/g, '\\"'

  drawFilterResizeIcon: =>
    if @$el.find("#filters.animated").hasClass("w-0")
      @$("#filters_resize").children('i.fa.fa-chevron-left').addClass("d-none")
      @$("#filters_resize").children('i.fa.fa-filter').removeClass("d-none")

    else
      @$("#filters_resize").children('i.d-none.fa.fa-chevron-left').removeClass("d-none")
      @$("#filters_resize").children('i.fa.fa-filter').addClass("d-none")

  onResizeFilter: =>
    @showingFilters = !@showingFilters
    @$el.find("#filters.animated").toggleClass("w-0")
    @drawFilterResizeIcon()
    resizeCharts()
    if @chartView
      @chartView.masonry()
